export enum AccessTokensStaticActionType {
  Delete = 'delete',
}
